module.exports = "<div [ngStyle]=\"menucss\" class=\"context-menu-container\">\n    <ul class=\"links-wrapper\">\n        <li (click)=\"link.subject.next(link.title)\" class=\"link\" *ngFor=\"let link of links\">\n            {{link.title}}\n        </li>\n    </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/context-menu/context-menu-holder.html
// module id = nVcp
// module chunks = 0